import PAGE from "@/components/page/lang/lang-en";
import EMG from "@/views/emg/lang/lang-en";
import BUSINESS from "@/views/business/lang/lang-en";


export const login = {
  login: 'Login',
  choiceProject: "Please choose project",
  choiceLang: "Please choose language",
  password: 'Password',
}
export const common = {
  edit: 'Edit',
  add: 'Add',
  delete: 'Delete',
  copy: 'Copy',
  date: 'Date',
  remark: 'Remark',
  handle: 'Handle',
  stop: 'Stop',
  start: 'Start',
  search: 'Search',
  reset: 'Reset',
  nodata: 'No date yet',
  cancel: 'Cancel',
  ok: 'Confirm',
  addNew: 'Add',
  layOut: 'Exit',
  status: 'Status',
  tip: 'Tips',
  import: "The import",
  export: "export",
  detail: "details",
  ifDelete: 'Confirm to cancel',
  conDelete: 'Cancel successfully',
  canDele: 'Cancel deleted ',
  ifStatus: 'Whether to disable?',
  ifStatus1: 'Whether to enable?',
  conStatus: "Disable the success!",
  conStatus1: "To enable successful!",
  canStatus: "Has been cancelled!",
  changeSu: 'Modify successfully',
  addSu: 'Add successfully',
  rulesText: '内容不能为空',
  trackerAuth: "用户追踪授权",
  startTime: "Start Time",
  endTime: "End Time",
}
export const menu = {
  chName: 'Chinese name',
  enName: 'English name',
  vnName: 'Vietnamese name',
  component: 'Component name',
  pathName: 'Visiting path',
  comPath: 'Component path',
  choiceIcon: 'Choose icon',
  icon: 'Icon',
  sort: 'Sorting vale',
  editMenu: 'Edit menu',
  addMenu: 'Add menu',
}
export const role = {
  addRole: 'Add role',
  role: 'Role',
  editRoleName: 'Edit role',
  roleName: 'Role name',
  menuControl: ' Menu authority',
  columnAuth: 'Column authority',
}
export const user = {
  addUser: 'Add user',
  user: 'User',
  editUserName: 'Edit user',
  companyChoice: 'Choose company',
  roleChoice: ' Choose role',
  businessChoice: 'Choose task',
  nickName: 'Nickname',
  loginName: 'Login name',
  email: 'Email',
  phone: 'Mobile phone',
  userStatus: 'User status',
  resetPass: 'Reset password'
}
export const whiteList = {
  synchronism: 'Synchronize',
  platFormName: ' Platform name',
  modules: 'Modules',
  domain: 'Domain',
  gateWay: 'Gateway',
}
export const company = {
  companyName: 'Business name',
  bandGate: 'Bind gateway',
  resetKey: ' Reset key',
  businessChioce: 'Choose business',
  businessHolder: 'Please choose business'
}
export const job = {
  jobName: 'Task name',
  jobClass: 'Task grouping',
  jobDes: 'Describe task',
  jobDo: 'Executing task class',
  cron: 'cron Expression',
  wait: 'Wait',
  pause: 'Pause',
  executed: 'Executed normally',
  block: 'Block',
  error: 'Error',
  startOff: 'Start off',
  pauseJob: 'Pause task',
  backJob: 'Recover task',
  confimStart: 'Are you sure to activate this task ',
  startSucc: 'Activate successfully'
}
export const message = {
  messageClass: 'Pushing class',
  type: 'Class',
  moduleCode: 'code Module code',
  content: 'Content',
  ipLimit: 'IP limit',
  phoneLimit: 'Phone limit',
  time: 'Appointed time',
  sendType: 'Sending class',
  ipHolder: 'How many verification code can be sent with 1 IP on 1 day',
  phoneHolder: 'How many verification code can be sent in 1 phone on 1 day',
  timeHolder: ' If it is in the appointed time when sent massage(valid in 60s by default)',
  autoSend: 'Auto send',
  timeSend: 'Send on time',
  otherMessage: 'Other inform messages',
  verification: 'Verification code',
}
export const gateWay = {
  programId: ' Project ID',
  programName: ' Project name',
  predicates: 'predicates',
  gateUri: 'Gateway Uri',
  Gateway: 'Gateway',
}
export const thisCompany = {
  companyName: ' Company’s name',
  companyCode: 'Company’s code',
  loginName: 'Login name',
  niceName: 'User’s nickname',
  phone: 'Phone number'
}
export const menuName = {
  home: 'Home',
  sysName: 'System management',
  menuManage: 'Menu management',
  userManage: 'User management',
  whiteManage: ' White list management',
  compangManage: ' Company management',
  jobManage: 'Task management',
  messageManage: ' Massage management',
  gateWayManage: ' Gateway management',
  businessManage: ' Business management',
  myCompany: ' My company',
  companyBasic: 'Company’s basic information'
}

export const page = PAGE;
export const emg = EMG;
export const business = BUSINESS;
